import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54f164fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-bg" }, null, -1))
const _hoisted_3 = { class: "login-content" }
const _hoisted_4 = { class: "tab-content hea-row hea-justifyC" }
const _hoisted_5 = { class: "hea-flex-item1" }
const _hoisted_6 = { class: "hea-column" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-tip" }, "未成年人体检，请输入投保人手机号", -1))
const _hoisted_8 = { class: "nr" }
const _hoisted_9 = { class: "notice-content hea-row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/images/login/notice.png",
  alt: "",
  class: "notice-ico"
}, null, -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode("关于友邦将如何处理和使用您的个人信息，请阅读")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("和")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 登录 ")
const _hoisted_14 = {
  key: 0,
  class: "register-tip hea-justifyC"
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode("没有账号，")

import { computed, defineComponent, getCurrentInstance, nextTick, onMounted, reactive, ref } from 'vue';
    import { Toast } from 'vant';
    import JSEncryptUtils from 'utils/encrypt-utils';
    import dayjs from 'dayjs';
    import { AuthService,GaodeService } from 'src/services';
    import { useToken, useUserInfo } from 'src/store';
    import { useRouter, useRoute } from 'vue-router';
    import patterns from "src/utils/patterns";
    import sensors from "src/sensors";
    import Register from "./register";
    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const { proxy } : any = getCurrentInstance(); 
    const { setAccessToken, setRefreshToken } = useToken();
    const { setUserInfo } = useUserInfo();
    const router = useRouter();
    const route = useRoute();

    // 切换
    let tabIndex = ref<number>(1);

    // 密码输入框图标
    let showPwd = ref<boolean>(false);

    // 登录信息
    let formData = reactive<any>({
        phone: "",
        password: ""
    })
    let isJSON = (data) =>{
        try {
            JSON.parse(data);
            return true;
        } catch (e) {
            return false;
        }
    }
    
    onMounted(()=>
    {
        if (localStorage.getItem("loginData") && isJSON(localStorage.getItem("loginData")))
        {
            formData.phone = JSON.parse(localStorage.getItem("loginData")).phone;
            formData.password = JSON.parse(localStorage.getItem("loginData")).password;
        }
        localStorage.clear();
        // getGeolocation(); 
    })
    
    // 登入
    const onSubmit = async ()=>
    {
        try
        {
            let data = {
                timestamp:Math.floor(dayjs().valueOf() / 1000),
                phone: formData.phone,
                password: formData.password
            }
            let {content: result} = await AuthService.instance.login({
                bodyStr: JSEncryptUtils.decrypt(JSON.stringify(data))
            })

            if(result.data)
            {
                setAccessToken(result.data.accessToken);
                setRefreshToken(result.data.refreshToken);
                sensors.bind("identity_Id",result.data.userId +"");
                // localStorage.setItem("location", JSON.stringify({
                //     lat:result.data.lat,
                //     lng:result.data.lng,
                //     city:result.data.city
                // }));
                setUserInfo(result.data);
                nextTick(()=>
                {
                    router.push({name: "home"});
                })
               
            }
        }
        catch(err)
        {
            Toast({
                message: err,
                duration: 4000
            })
        }
    }

    // 页面跳转
    const onPage = (name: string) =>
    {
        if (name == 'fileNotice')   // 跳转告知书
        {
            localStorage.setItem("loginData", JSON.stringify(formData))
        }
        router.push({name: name});
    }

    /**
     * 验证是否正确手机号
     * @private
     * @returns void
     */
    const validatorPhone = (val: any): any =>
    {
        return patterns.mobile.test(val);
    }
    

return (_ctx: any,_cache: any) => {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: _normalizeClass(["hea-flex-item1 tab hea-justifyC", {'active' : _unref(tabIndex) == 1}]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(tabIndex) //@ts-ignore
 ? tabIndex.value = 1 : tabIndex = 1))
        }, " 注册 ", 2),
        _createElementVNode("div", {
          class: _normalizeClass(["hea-flex-item1 tab hea-justifyC", {'active' : _unref(tabIndex) == 2}]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_isRef(tabIndex) //@ts-ignore
 ? tabIndex.value = 2 : tabIndex = 2))
        }, " 登录 ", 2)
      ]),
      (_unref(tabIndex) == 1)
        ? (_openBlock(), _createBlock(_unref(Register), {
            key: 0,
            onChangeTab: _cache[2] || (_cache[2] = ($event: any) => (_isRef(tabIndex) //@ts-ignore
 ? tabIndex.value = 2 : tabIndex = 2))
          }))
        : _createCommentVNode("", true),
      (_unref(tabIndex) == 2)
        ? (_openBlock(), _createBlock(_component_van_form, {
            key: 1,
            onSubmit: onSubmit,
            class: "hea-column mt26"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_van_field, {
                    clearable: "",
                    modelValue: _unref(formData).phone,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(formData).phone) = $event)),
                    name: "phone",
                    placeholder: "请输入友邦预留手机号码",
                    rules: [{ validator: validatorPhone, message: '请输入完整手机号' }],
                    maxlength: "11"
                  }, null, 8, ["modelValue", "rules"]),
                  _hoisted_7
                ]),
                _createVNode(_component_van_field, {
                  onClickRightIcon: _cache[4] || (_cache[4] = () => _isRef(showPwd) //@ts-ignore
 ? showPwd.value = !_unref(showPwd) : showPwd = !_unref(showPwd)),
                  "right-icon": !_unref(showPwd) ? 'closed-eye' : 'eye-o',
                  class: "mt26",
                  clearable: "",
                  modelValue: _unref(formData).password,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(formData).password) = $event)),
                  type: _unref(showPwd) ? 'text' : 'password',
                  name: "password",
                  placeholder: "请输入密码",
                  rules: [{ required: true, message: '请输入密码' }]
                }, null, 8, ["right-icon", "modelValue", "type"]),
                _createElementVNode("div", {
                  class: "forget-password",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (onPage('updatePwd')))
                }, "忘记密码")
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("div", null, [
                    _hoisted_11,
                    _createElementVNode("span", {
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (onPage('fileNotice')))
                    }, "《个人信息处理规则告知书》"),
                    _hoisted_12,
                    _createElementVNode("span", {
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (onPage('filePrivacy')))
                    }, "《隐私声明》")
                  ])
                ]),
                _createVNode(_component_van_button, {
                  round: "",
                  block: "",
                  "native-type": "submit",
                  class: "submit-btn hea-justifyC",
                  color: "linear-gradient(to right, #F8628A, #E23A67)"
                }, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                }),
                (_unref(tabIndex) == 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _hoisted_15,
                      _createElementVNode("span", {
                        class: "register-btn",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_isRef(tabIndex) //@ts-ignore
 ? tabIndex.value = 1 : tabIndex = 1))
                      }, "前往注册")
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})